<!--
component: BrowseDaicho
author: Takumi Ogura
description: 台帳記載証明閲覧画面
-->
<template>
	<section class="daicho">
		<v-container fluid class="pt-0 px-0">
			<div class="head-message">{{ message }}</div>
			<v-row class="pt-2" justify="center">
				<v-col align-self="center">
					<v-card :height="$vuetify.breakpoint.height - 200" width="100%" class="mx-auto">
						<v-row>
							<v-col cols="4" sm="5" md="5" class="py-0 pr-0">
								<v-row class="ma-1 orange lighten-2 overflow-y-auto" :style="'height:' + ($vuetify.breakpoint.height - 217) + 'px;'">
									<v-col>
										<!-- 受付番号 -->
										<v-row style="white-space: nowrap;">
											<v-col class="pb-1">
												<v-row align="center">
													<v-col align="left" cols="3">
														&nbsp;受付番号
													</v-col>
													<v-col cols="9">
														<v-text-field filled hide-details dense class="align-center" v-model="ledgerData.rcpNo" readonly>
															<template v-slot:prepend>
																<span class="">第</span>
															</template>
															<template v-slot:append-outer>
																<span>号</span>
															</template>
														</v-text-field>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
										<!-- 確認番号 -->
										<v-row style="white-space: nowrap;">
											<v-col class="py-1">
												<v-row align="center">
													<v-col align="left" cols="3">
														&nbsp;確認番号
													</v-col>
													<v-col cols="9">
														<v-text-field filled hide-details dense class="align-center" v-model="ledgerData.cnfNo" readonly>
															<template v-slot:prepend>
																<span>第</span>
															</template>
															<template v-slot:append-outer>
																<span>号</span>
															</template>
														</v-text-field>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
										<!-- 発行系 -->
										<v-row>
											<v-col class="pt-0">
												<v-card class="orange lighten-4">
													<v-row class="ma-1" style="white-space: nowrap;">
														<v-col class="py-2">
															<v-row>
																<v-col class="pb-1">
																	<v-row align="center">
																		<v-col cols="4" align="left" class="px-1">&nbsp;発行番号</v-col>
																		<v-col cols="8" class="px-1">
																			<v-tooltip top>
																				<template v-slot:activator="{ on, attrs }">
																					<v-text-field
																						solo hide-details dense class="align-center"
																						style="font-size:16px !important;"
																						v-model="ledgerData.issue.no"
																						maxLength="5"
																						v-bind="attrs"
																						v-on="on">
																						<template v-slot:prepend>
																							<span>第</span>
																						</template>
																						<template v-slot:append-outer>
																							<span>号</span>
																						</template>
																					</v-text-field>
																				</template>
																				<span>5桁まで入力可能です。</span>
																			</v-tooltip>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
															<v-row>
																<v-col class="py-1">
																	<v-row align="center">
																		<v-col cols="4" align="left" class="px-1">&nbsp;発行日</v-col>
																		<v-col cols="8" align="center" class="px-1">
																			<DatePicker ref="issueDatePicker" v-model="date" @clear="ledgerData.issue.date = $event"/>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
															<v-row>
																<v-col class="py-1">
																	<v-row align="center">
																		<v-col cols="4" align="left" class="px-1">&nbsp;発行者氏名</v-col>
																		<v-col cols="8" class="px-1">
																			<v-text-field solo hide-details dense v-model="ledgerData.issue.person"></v-text-field>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
															<v-row>
																<v-col class="pt-1">
																	<v-row align="center">
																		<v-col cols="4" align="left"></v-col>
																		<v-col cols="8" class="px-1">
																			<v-select
																			:items="ledgerType"
																			item-text="name"
																			item-value="name"
																			v-model="ledgerData.issue.ledgerType"
																			solo
																			hide-details
																			dense
																			no-data-text="選択可能なデータはありません。"
																		></v-select>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
										<!-- 内容変更系 -->
										<v-row class="mt-1">
											<v-col class="pt-0">
												<v-card class="">
													<v-card-title class="pa-0">
														<v-tabs
															v-model="tab"
															background-color="light-blue lighten-2"
															grow
															show-arrows
														>
															<v-tab
																v-for="item in tabItems"
																:key="item"
																style="font-weight: bold;"
															>
																{{ item }}
															</v-tab>
														</v-tabs>
													</v-card-title>
														<v-tabs-items v-model="tab" :dark="false" :light="false" active-class="light-blue lighten-4">
															<!-- 建築物の概要 -->
															<v-tab-item>
																<v-card-text class="pa-1" :style="'height:' + ($vuetify.breakpoint.height * 0.3) + 'px'" style="overflow-y: scroll;">
																	<v-row class="ma-1" style="white-space: nowrap;">
																		<v-col>
																			<v-row>
																				<v-col>
																					<v-row>
																						<v-col class="py-1">
																							敷地の地名地番
																						</v-col>
																					</v-row>
																					<v-row>
																						<v-col class="py-1 pr-1">
																							<v-textarea solo hide-details no-resize dense rows="2" v-model="ledgerData.build.gaiyo.placeLotNo"></v-textarea>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							主要用途
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field solo hide-details dense v-model="ledgerData.build.gaiyo.mainUse"></v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							敷地面積
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field type="Number" solo hide-details hide-spin-buttons dense class="align-center" v-model="ledgerData.build.gaiyo.siteArea">
																								<template v-slot:prepend>
																									<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
																								</template>
																								<template v-slot:append-outer>
																									<span>㎡</span>
																								</template>
																							</v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							建築面積
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field type="Number" solo hide-spin-buttons hide-details dense class="align-center" v-model="ledgerData.build.gaiyo.buildAreaApp">
																								<template v-slot:prepend>
																									<span>申請部分</span>
																								</template>
																								<template v-slot:append-outer>
																									<span>㎡</span>
																								</template>
																							</v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							建築面積
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field type="Number" solo hide-spin-buttons hide-details dense class="align-center" v-model="ledgerData.build.gaiyo.buildAreaNotApp">
																								<template v-slot:prepend>
																									<span>申請以外</span>
																								</template>
																								<template v-slot:append-outer>
																									<span>㎡</span>
																								</template>
																							</v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							延べ面積
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field type="Number" solo hide-spin-buttons hide-details dense class="align-center" v-model="ledgerData.build.gaiyo.totalAreaApp">
																								<template v-slot:prepend>
																									<span>申請部分</span>
																								</template>
																								<template v-slot:append-outer>
																									<span>㎡</span>
																								</template>
																							</v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							延べ面積
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field type="Number" solo hide-spin-buttons hide-details dense class="align-center" v-model="ledgerData.build.gaiyo.totalAreaNotApp">
																								<template v-slot:prepend>
																									<span>申請以外</span>
																								</template>
																								<template v-slot:append-outer>
																									<span>㎡</span>
																								</template>
																							</v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							構造
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field solo hide-details dense v-model="ledgerData.build.gaiyo.struct"></v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							階数
																						</v-col>
																						<v-col class="px-1" cols="8">
																							<v-row>
																								<v-col class="pr-1" cols="6">
																									<v-text-field type="Number" solo hide-details dense hide-spin-buttons class="align-center" v-model="ledgerData.build.gaiyo.ground">
																										<template v-slot:prepend>
																											<span>地上</span>
																										</template>
																									</v-text-field>
																								</v-col>
																								<v-col class="px-1" cols="6">
																									<v-text-field type="Number" solo hide-details dense hide-spin-buttons class="align-center" v-model="ledgerData.build.gaiyo.underGround">
																										<template v-slot:prepend>
																											<span>地下</span>
																										</template>
																									</v-text-field>
																								</v-col>
																							</v-row>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							棟数
																						</v-col>
																						<v-col class="px-1">
																							<v-text-field solo hide-details dense v-model="ledgerData.build.gaiyo.buildNum"></v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																		</v-col>
																	</v-row>
																</v-card-text>
															</v-tab-item>
															<!-- 建築主 -->
															<v-tab-item>
																<v-card-text class="pa-1" :style="'height:' + ($vuetify.breakpoint.height * 0.3) + 'px'" style="overflow-y: scroll;">
																	<v-row class="ma-1">
																		<v-col>
																			<v-row>
																				<v-col>
																					<v-row>
																						<v-col class="py-1">建築主住所</v-col>
																					</v-row>
																					<v-row>
																						<v-col class="py-1 pr-1">
																							<v-textarea solo hide-details no-resize dense rows="2" v-model="ledgerData.build.architectInfo.address"></v-textarea>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							建築主会社
																						</v-col>
																						<v-col class="pr-1">
																							<v-text-field filled hide-details dense v-model="ledgerData.build.architectInfo.company" readonly></v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							建築主肩書
																						</v-col>
																						<v-col class="pr-1">
																							<v-text-field filled hide-details dense v-model="ledgerData.build.architectInfo.position" readonly></v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-1">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							建築主氏名
																						</v-col>
																						<v-col class="pr-1">
																							<v-text-field solo hide-details dense v-model="ledgerData.build.architectInfo.name" @change="updateJoinNum()"></v-text-field>
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col class="py-2">
																					<v-row align="center">
																						<v-col cols="4" align="left" class="pr-1">
																							建築主数
																						</v-col>
																						<v-col class="pr-1">
																							{{ ledgerData.build.architectInfo.joinNum }} 人
																						</v-col>
																					</v-row>
																				</v-col>
																			</v-row>
																			<v-row>
																				<v-col>
																					<v-row>
																						<v-col class="py-1">連名者氏名</v-col>
																					</v-row>
																					<v-row>
																						<v-col class="py-1 pr-1">
																							<v-combobox
																								v-model="ledgerData.build.architectInfo.joinPerson"
																								@change="updateJoinNum()"
																								:allow-overflow="false"
																								append-icon=""
																								chips
																								clearable
																								deletable-chips
																								hide-selected
																								multiple
																								small-chips
																								solo
																								persistent-hint
																							>
																							</v-combobox>
																						</v-col>
																					</v-row>
																				</v-col>	
																			</v-row>
																		</v-col>
																	</v-row>
																</v-card-text>
															</v-tab-item>
															<!-- コメント -->
															<v-tab-item>
																<v-card-text :style="'height:' + ($vuetify.breakpoint.height * 0.3) + 'px'" style="overflow-y: auto;">
																	<v-row class="">
																		<v-col>
																			<v-row>
																				<v-col class="pa-2">
																					<v-textarea solo no-resize dense hide-details rows="6" v-model="ledgerData.build.comment"></v-textarea>
																				</v-col>
																			</v-row>
																		</v-col>
																	</v-row>
																	<v-row justify="end">
																		<v-col align="end" class="mt-1">
																			<v-btn
																				color="primary"
																				@click="registComment()"
																			>コメント登録</v-btn>
																		</v-col>
																	</v-row>
																</v-card-text>
															</v-tab-item>
														</v-tabs-items>
												</v-card>
											</v-col>
										</v-row>
										<!-- 印刷ボタン -->
										<v-row class="mt-1">
											<v-col class="pt-3">
												<v-row justify="center">
													<v-col  cols="4" align="right">
														<v-btn large block color="success" @click="printDialog = true"><v-icon>mdi-printer</v-icon>&nbsp;印刷</v-btn>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
						</v-col>
							<!-- 台帳記載証明書View -->
								<v-col cols="8" sm="7" md="7" class="py-0 pl-0 preview-col">
									<!-- 様式1: 申請書 (プレビュー表示) -->
									<v-row class="ma-1 preview-pane overflow-y-auto" :style="'max-height:' + ($vuetify.breakpoint.height - 217) + 'px;'" style="border-style: groove; background-color: gray;">
										<v-col class="pt-0 ma-1">
											<BrowseDaichoView :data="ledgerData" type="appForm"/>
										</v-col>
									</v-row>
									<!-- 印刷用: 様式1と様式2(非表示、印刷時のみ使用) -->
									<div style="display: none;">
										<BrowseDaichoView :data="ledgerData" type="appForm"/>
										<BrowseDaichoView :data="ledgerData" type="certificate"/>
										<BrowseDaichoView :data="ledgerData" type="electronic"/>
									</div>
								</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<!-- 印刷ボタンダイアログ -->
			<v-dialog id="printDialog" width="30%" v-model="printDialog">
				<v-card>
					<v-card-title><v-icon large>mdi-printer</v-icon>&nbsp;記載証明書印刷</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-row>
							<v-col>
								<v-radio-group
									v-model="printType"
									mandatory
									hide-details
								>
									<v-radio
										label="申請書"
										value="0"
									></v-radio>
									<v-radio
										label="証明書"
										value="1"
									></v-radio>
									<v-radio
										label="申請書および証明書の一括出力"
										value="2"
									></v-radio>
									<v-radio
										label="電子交付用証明書"
										value="3"
									></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
								<v-btn
									color="green darken-1"
									text
									@click="printDialog = false"
								>
									キャンセル
								</v-btn>
								<v-btn
									color="green darken-1"
									text
									@click="exePrint()"
								>
									OK
								</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!-- フラッシュメッセージダイアログ -->
			<v-dialog v-model="flashDialog" width="30%">
				<v-card>
					<v-card-title class="text-h6 px-5">
						<v-icon large color="success">mdi-checkbox-marked-circle-outline</v-icon>&nbsp;確認メッセージ
					</v-card-title>
					<v-card-text class="pb-0">
						コメントを登録しました。
					</v-card-text>
					<v-card-actions class="pt-0">
						<v-spacer></v-spacer>
						<v-btn text color="success" @click="flashDialog = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
        :title="'ユーザー認証'" :body="'ユーザー認証に失敗しました。ログインし直して下さい。'"/>
		</v-container>
	</section>
</template>
<script>
import BrowseDaichoView from '../components/BrowseDaichoView.vue'
import Dialog from '../components/Dialog.vue'
import DatePicker from '../components/DatePicker.vue'
//import Const from '../common/constants.js'
import { callGetApi, callPostApi, registLog } from '../common/apiAccess'
import { apiUrl } from '../common/utils'
export default {
	name: 'browsedaicho',
	components:{
		BrowseDaichoView,
		DatePicker,
		Dialog
	},
	data(){
		return {
			ledgerData:{
				constructType: [],
				rcpNo: '',
				cnfNo: '',
				issue:{
					no: null,
					date: '',
					person: '',
					ledgerType: '確認申請台帳',
				},
				build:{
					gaiyo:{
						placeLotNo: '',
						mainUse: '',
						siteArea: null,
						buildAreaApp: null,
						buildAreaNotApp: null,
						totalAreaApp: null,
						totalAreaNotApp: null,
						struct: '',
						ground: null,
						underGround: null,
						buildNum: null,
					},
					architectInfo:{
						address: '',
						company: '',
						position: '',
						name: '',
						joinNum: null,
						joinPerson: [],
					},
					comment: '',
				},
				ukeNo: null,
				ukeDay: null,
				kknnNo: null,
				kknnDay: null,
				henkoNo: null,
				henkoDay: null,
				chukanNo1: null,
				chukanDay1: null,
				chukanNo2: null,
				chukanDay2: null,
				kenzumiNo: null,
				kenzumiDay: null,
			},
			ledgerType: ['確認申請台帳','変更申請台帳','中間検査台帳','完了検査台帳','建築確認台帳'],
			tab: null,
			tabItems:['建築物の概要','建築主','コメント'],
			personList: ['a','b','c'],
			printDialog: false,
			printType: "0",
			flashDialog: false,
			// メッセージダイアログ
      authDialog: false,
		}
	},
	computed:{
		mode: {
			get() { return this.$store.state.mode; },
			set(val) { this.$store.commit('setMode', val); }
		},
		token () {
			return this.$store.state.token;
		},
		unauthorized () {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized () {
			return !this.unauthorized;
		},
		message () {
			return "台帳記載証明書";
		},
		date: {
			get() {
				return this.ledgerData.issue.date;
			},
			set(val) {
				this.ledgerData.issue.date = val;
				//年度内開庁日の連番を取得し格納
        const url = apiUrl('KisaiNo') + '?date=' + val;
        callGetApi(url, (data) => {
          if (data.errorCode === undefined) {
            this.ledgerData.issue.no = data;
          }
        });
			}
		},
	},
	mounted() {
		if (this.unauthorized) {
			this.authDialog = true;
		}
		this.$store.commit('setCurrentPage', 3);
    // APIで取得したデータをセット
    const dbData = this.$store.state.kisaiData;
		//console.log(dbData);
		this.ledgerData.rcpNo = dbData.ukeNo != null ? dbData.ukeNo : '';
		this.ledgerData.cnfNo = dbData.kknnNo != null ? dbData.kknnNo : '';
		this.ledgerData.ukeNo = dbData.ukeNo != null ? dbData.ukeNo : '';
		this.ledgerData.ukeDay = dbData.ukeDay != null ? this.convDate(dbData.ukeDay) : '';
		this.ledgerData.issue.no = dbData.hakkoNo != null ? dbData.hakkoNo : '';
		this.ledgerData.issue.date = dbData.hakkoDate != null ? dbData.hakkoDate.replaceAll('/','-') : '';
		this.$refs.issueDatePicker.picker = dbData.hakkoDate != null ? dbData.hakkoDate.replaceAll('/','-') : '';
		this.$refs.issueDatePicker.pickerText = dbData.hakkoDate != null ? dbData.hakkoDate.replaceAll('/','-') : '';
		//this.ledgerData.issue.person = dbData.hakkosha != null ? dbData.hakkosha : '';
		this.ledgerData.issue.ledgerType = dbData.ledgerType != null ? dbData.ledgerType : '';
		this.ledgerData.build.gaiyo.placeLotNo = dbData.timeiTiban != null ? dbData.timeiTiban : '';
		this.ledgerData.build.gaiyo.mainUse = dbData.yoto != null ? dbData.yoto : '';
		this.ledgerData.build.gaiyo.siteArea = dbData.shikichi != null ? dbData.shikichi : '';
		this.ledgerData.build.gaiyo.buildAreaApp = dbData.kenmenBubun != null ? dbData.kenmenBubun : 0;
		this.ledgerData.build.gaiyo.buildAreaNotApp = dbData.kenmenIgai != null ? dbData.kenmenIgai : 0;
		this.ledgerData.build.gaiyo.totalAreaApp = dbData.nobemenBubun != null ? dbData.nobemenBubun : 0;
		this.ledgerData.build.gaiyo.totalAreaNotApp = dbData.nobemenIgai != null ? dbData.nobemenIgai : 0;
		this.ledgerData.build.gaiyo.struct = dbData.kozo != null ? dbData.kozo : '';
		this.ledgerData.build.gaiyo.ground = dbData.chijoKaisu != null ? dbData.chijoKaisu : 0;
		this.ledgerData.build.gaiyo.underGround = dbData.chikaKaisu != null ? dbData.chikaKaisu : 0;
		this.ledgerData.build.gaiyo.buildNum = dbData.munesu != null ? dbData.munesu : 0;
		this.ledgerData.build.architectInfo.address = dbData.builderAddr != null ? dbData.builderAddr : '';
		this.ledgerData.build.architectInfo.company = dbData.builderCompany != null ? dbData.builderCompany : '';
		this.ledgerData.build.architectInfo.position = dbData.builderPost != null ? dbData.builderPost : '';
		this.ledgerData.build.architectInfo.name = dbData.builderName != null ? dbData.builderName : '';
		this.ledgerData.build.architectInfo.joinPerson = dbData.renmeisha != null ? dbData.renmeisha : [];
		this.ledgerData.build.comment = dbData.comment != null ? dbData.comment : '';
		this.ledgerData.kknnNo = dbData.orgKknnNo,
		this.ledgerData.kknnDay = this.convDate(dbData.orgKknnDay),
		this.ledgerData.henkoNo = dbData.henkoNo,
		this.ledgerData.henkoDay = this.convDate(dbData.henkoDay),
		this.ledgerData.chukanNo1 = dbData.chukanNo1,
		this.ledgerData.chukanDay1 = this.convDate(dbData.chukanDay1),
		this.ledgerData.chukanNo2 = dbData.chukanNo2,
		this.ledgerData.chukanDay2 = this.convDate(dbData.chukanDay2),
		this.ledgerData.kenzumiNo = dbData.kenzumiNo,
		this.ledgerData.kenzumiDay = this.convDate(dbData.kenzumiDay),
		dbData.shintiku ? this.ledgerData.constructType.push('0') : '';
		dbData.zoutiku ? this.ledgerData.constructType.push('1') : '';
		dbData.kaitiku ? this.ledgerData.constructType.push('2') : '';
		dbData.iten ? this.ledgerData.constructType.push('3') : '';
		dbData.yotohenkou ? this.ledgerData.constructType.push('4') : '';
		dbData.daishuzen ? this.ledgerData.constructType.push('5') : '';
		dbData.daimoyougae ? this.ledgerData.constructType.push('6') : '';

		// 建築主数
		if(dbData.builderName != '' || dbData.builderName != null){
			this.ledgerData.build.architectInfo.joinNum = 1 + (dbData.renmeisha != null ? dbData.renmeisha.length : 0);
		}else{
			this.ledgerData.build.architectInfo.joinNum = (dbData.renmeisha != null ? dbData.renmeisha.length : 0);
		}

		// 閲覧ログ取得
		registLog([[104, '記載証明書閲覧', this.ledgerData.rcpNo, this.ledgerData.cnfNo]]);
	},
	methods: {
		// 印刷処理
		exePrint() {
			this.printDialog = false;
			
			setTimeout(() => {
				// 非表示の印刷用要素から取得
				var hiddenContainer = document.querySelector('.preview-col > div[style*="display: none"]');
				var appFormPage = hiddenContainer.querySelector('.type-appForm');
				var certificatePage = hiddenContainer.querySelector('.type-certificate');
				
				// body内を非表示
				document.body.getElementsByTagName('noscript')[0].style.display = 'none';
				document.body.getElementsByTagName('div')[0].style.display = 'none';
				
				// 印刷用コンテナを作成
				var printContainer = document.createElement('div');
				printContainer.setAttribute('id','print');
				printContainer.setAttribute('style','width: 210mm !important;');
				
				switch(this.printType){
					// 申請書の場合
						case "0": {
						// 記載証明発行ログを記録
						registLog([[103, '台帳記載証明書発行[申請書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo]]);
						
							const page1Clone = appFormPage.cloneNode(true);
						page1Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative;';
						printContainer.appendChild(page1Clone);
						break;
					}
					// 証明書の場合
						case "1": {
						// 記載証明発行ログを記録
						registLog([[103, '台帳記載証明書発行[証明書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo]]);
						
						const page2Clone = certificatePage.cloneNode(true);
						page2Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative;';
						printContainer.appendChild(page2Clone);
						break;
					}
					// 申請書、証明書一括出力
						case "2": {
						// 記載証明発行ログを記録
						registLog([
							[103, '台帳記載証明書発行[申請書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo],
							[103, '台帳記載証明書発行[証明書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo]
						]);
						
						// 1ページ目(appForm)をクローンして追加
						const page1Clone = appFormPage.cloneNode(true);
						page1Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative; page-break-after: always;';
						printContainer.appendChild(page1Clone);
						
						// 2ページ目(certificate)をクローンして追加
						const page2Clone = certificatePage.cloneNode(true);
						page2Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative;';
						printContainer.appendChild(page2Clone);
						break;
					}
					// 電子交付用証明書の場合
						case "3": {
						// 記載証明発行ログを記録
						registLog([[113, '台帳記載証明書発行[電子交付用証明書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo]]);
						
						var electoronicPage = hiddenContainer.querySelector('.type-electronic');
						const page2Clone = electoronicPage.cloneNode(true);
						page2Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative;';
						printContainer.appendChild(page2Clone);
						break;
					}

				}
				
				document.body.appendChild(printContainer);
				
				const restoreDisplay = () => {
					printContainer.remove();
					document.body.getElementsByTagName('noscript')[0].style.display = 'block';
					document.body.getElementsByTagName('div')[0].style.display = 'block';
				};
				window.onafterprint = restoreDisplay;
				// 印刷
				window.print();
				restoreDisplay();
			},500);
		},
		// 建築主数更新処理および連名者氏名入力制御
		updateJoinNum() {
			// if(this.ledgerData.build.architectInfo.joinPerson.length <= 10){
				if(this.ledgerData.build.architectInfo.name != ''){
					this.ledgerData.build.architectInfo.joinNum = 1 + this.ledgerData.build.architectInfo.joinPerson.length;
				}else {
					this.ledgerData.build.architectInfo.joinNum = this.ledgerData.build.architectInfo.joinPerson.length;
				}
			// }else{
			// 	this.ledgerData.build.architectInfo.joinPerson.pop();
			// }
			
		},
		// 日付変換処理(0埋めで来る値を空白に変換 ex:平成09年12月01日 → 平成 9年12月 1日)
		convDate(date){
			if(date == '' || date == null){
				return '';
			}

			const text = String(date);
			const match = text.match(/^(.*?)(元|\d+)年(\d{1,2})月(\d{1,2})日$/);
			if (!match) {
				return text;
			}

			const era = match[1];
			const year = match[2];
			const month = match[3].padStart(2, ' ');
			const day = match[4].padStart(2, ' ');
			return `${era}${year}年${month}月${day}日`;
		},
		// コメント登録
		registComment() {
			// 登録処理
			this.flashDialog = true;
			// setTimeout(() => {
			// 	this.flashDialog = false;
			// },3000);
      const param = { ukeNo: this.ledgerData.rcpNo, comment: this.ledgerData.build.comment };
      callPostApi(apiUrl('KisaiComment'), param, () => {
				this.flashDialog = false;
       });
		}
	},
	watch: {
		'$store.state.hakkosha': {
			immediate: true,
			handler(val) {
				if (val) {
					this.ledgerData.issue.person = val;
				}
			}
		}
  }
}
</script>
<style scoped>
.v-input{
	font-size: 10pt !important;
}
@media print {
	@page{
		margin-left: 8mm !important;
		margin-right: 8mm !important;
		margin-top: 12mm !important;
		margin-bottom: 5mm !important;
	}
}
.A4 {
  height: 297mm !important;
  width: 210mm !important;
	display: flex !important;
}

.MSPGOTHIC {
  font-family: "MS PGothic";
}

.MSGOTHIC {
  font-family: "MS Gothic",sans-serif;
}

.header-font {
  font-size: 18pt !important;
  color: #000;
  height: 32px !important;
}

.font-size-11 {
  font-size: 11pt !important;
}

.font-size-12 {
  font-size: 12pt !important;
}

.font-size-13 {
  font-size: 13pt !important;
}

.font-size-9 {
  font-size: 9pt !important;
}

.font-black {
  color: #000;
}

.text-vertical {
  writing-mode: vertical-rl;
  text-align: center;
  white-space: nowrap;
  margin: 0;
  line-height: 1em;
}

.border-top {
  border-top: solid 1px;
}

.border-right {
  border-right: solid 1px;
}

.border-top-left {
  border-top: solid 1px;
  border-left: solid 1px;
}

.border-top-right {
  border-top: solid 1px;
  border-right: solid 1px;
}

.border-box {
  border: solid 1px !important;
}

.border-tx {
  border-top: solid 1px;
  border-left: solid 1px;
  border-right: solid 1px;
}

.border-tr {
  border-top: solid 1px;
  border-right: solid 1px;
}

.border-bx {
  border-bottom: solid 1px !important;
  border-left: solid 1px;
  border-right: solid 1px;
}

.border-br {
  border-bottom: solid 1px !important;
  border-right: solid 1px;
}

/* tbody > tr > td {
  height: 25px !important;
} */

.cellHeight-35 {
  height: 35px !important;
}

.cellHeight-28 {
  height: 28px !important;
}

.cellHeight-24 {
  height: 24px;
}

.cellHeight-22 {
  height: 22px !important;
}

.cellHeight-8 {
  height: 8px !important;
}

.lineHeight {
  line-height: 1px;
}

/* v-simple-tableにデフォルトで付与してあるhoverを無効化 */
tr:hover {
  background-color: transparent !important;
}

thead:hover {
  background-color: transparent !important;
}

/* tbody > tr > td {
  border: solid 0.1px !important;
} */

/* v-simple-tableにデフォルトで付与してある下線を無効化 */
tbody > tr > td{
  border-bottom: none !important;
  border: none;
}

tfoot > tr > td {
  border-top: none !important;
}

.v-radio >>> .v-icon {
  font-size: 18px;
}

.v-input--radio-group {
  margin-top: 0px;
}

.v-radio >>> .v-input--selection-controls__input {
  margin-right: 0px !important;
}
</style>
